var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-field',[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('md-input',{ref:"input",attrs:{"value":_vm.value,"type":"text","required":_vm.required},on:{"input":function($event){return _vm.$emit('update:value', $event)}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }